import { createModel } from "@rematch/core";
import { CustomerContactsTopFlopCombinationsState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, signoutIfUnauthorized } from "./utilities";

const initialState: CustomerContactsTopFlopCombinationsState = {
  combinations: [],
  loading: true,
};

export const customerContactsTopFlopCombinations = createModel<RootModel>()({
  state: initialState as CustomerContactsTopFlopCombinationsState,
  reducers: {
    fetchPending(state) {
      return { ...state, loading: true };
    },
    fetchSuccess(
      state,
      payload: Partial<CustomerContactsTopFlopCombinationsState>
    ) {
      return {
        ...state,
        ...payload,
        loading: false,
      };
    },
    fetchFail(state) {
      return { ...state, loading: false };
    },
  },
  effects: (dispatch) => ({
    async fetchCustomerContactsTopFlopCombinations(
      { nba_uuid, categories }: { nba_uuid: string; categories: string[] },
      rootState
    ) {
      dispatch.customerContactsTopFlopCombinations.fetchPending();

      const token = checkToken(rootState, () =>
        dispatch.customerContactsTopFlopCombinations.fetchFail()
      );
      if (!token) return;

      try {
        const customerContactsTopFlopCombinationsResult = await api.fetchCustomerContactsTopFlopCombinations(
          {
            token,
            nba_uuid,
            categories,
          }
        );
        dispatch.customerContactsTopFlopCombinations.fetchSuccess(
          customerContactsTopFlopCombinationsResult.data
        );
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.customerContactsTopFlopCombinations.fetchFail();
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/customerContactsTopFlopCombinations.ts